import Invites from './Invites.jsx';

export default Invites;
